export default "__VITE_ASSET__CD$Nv0h7__"